(function () {
  function initSipitProduct(root) {
    if (!root || root.dataset.sipitInit === '1') return;
    root.dataset.sipitInit = '1';

    const mainImg = root.querySelector('[data-sipit-main-img]');
    const mainVid = root.querySelector('[data-sipit-main-vid]');
    const mainVidEl = mainVid?.tagName === 'VIDEO' ? mainVid : mainVid?.querySelector('video');
    const thumbs = root.querySelectorAll('[data-sipit-thumb]');
    const flavs = root.querySelectorAll('[data-sipit-flav]');
    const modes = root.querySelectorAll('[data-sipit-mode]');
    const qInput = root.querySelector('[data-sipit-qty]');
    const qPlus = root.querySelector('[data-sipit-qty-plus]');
    const qMinus = root.querySelector('[data-sipit-qty-minus]');
    const priceNow = root.querySelector('[data-sipit-price-now]');
    const priceWas = root.querySelector('[data-sipit-was]');
    const priceSave = root.querySelector('[data-sipit-save]');
    const btnPrice = root.querySelector('[data-sipit-btn-price]');
    const sbPrice = root.querySelector('[data-sipit-sb-price]');
    const perServe = root.querySelector('[data-sipit-per-serve]');
    const perPouchTemplate = perServe?.dataset.perPouchTemplate || '$__PER__ / pouch';
    const sbTitle = root.querySelector('[data-sipit-sb-title]');
    const variantInput = root.querySelector('[data-sipit-variant-id]');
    const frequencySelect = root.querySelector('[data-sipit-frequency]');
    const frequencyWrap = root.querySelector('[data-sipit-frequency-wrap]');
    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    const addBtn = root.querySelector('[data-sipit-add-btn]');
    const buyNowBtn = root.querySelector('[data-sipit-buy-now]');
    const buyNowPrice = root.querySelector('[data-sipit-buy-now-price]');
    const sbAdd = root.querySelector('[data-sipit-sb-add]');
    const stickyBar = root.querySelector('[data-sipit-sticky-bar]');
    const packOffers = root.querySelectorAll('[data-sipit-pack]');
    const packPicker = root.querySelector('[data-sipit-pack-picker]');
    const packTrigger = root.querySelector('[data-sipit-pack-trigger]');
    const packMenu = root.querySelector('[data-sipit-pack-menu]');
    const packCurrent = root.querySelector('[data-sipit-pack-current]');
    const hasPackOffers = root.dataset.hasPackOffers === 'true';

    let variantMap = [];
    const variantMapEl = root.querySelector('[data-sipit-variant-map]');
    if (variantMapEl) {
      try {
        variantMap = JSON.parse(variantMapEl.textContent || '[]');
      } catch (e) {
        variantMap = [];
      }
    }

    const servingsPerPouch = parseInt(root.dataset.servings || '15', 10) || 15;

    let activePrice = parseFloat(root.dataset.defaultPrice || '0');
    let adding = false;
    let currentEntry = null;

    function getSubscribePriceForEntry(entry) {
      if (!entry) return NaN;
      const planId = frequencySelect ? (frequencySelect.value || '').trim() : '';
      if (planId && entry.subscribePrices && Object.prototype.hasOwnProperty.call(entry.subscribePrices, planId)) {
        const planPrice = parseFloat(entry.subscribePrices[planId]);
        if (Number.isFinite(planPrice)) return planPrice;
      }
      return entry.subscribePrice;
    }

    function getActivePack() {
      return root.querySelector('[data-sipit-pack].active')?.dataset.pack || '';
    }

    function getActiveFlavor() {
      return root.querySelector('[data-sipit-flav].active')?.dataset.flavor || '';
    }

    function setPackPickerOpen(open) {
      if (!packMenu || !packTrigger) return;
      packMenu.hidden = !open;
      packTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      packPicker?.classList.toggle('is-open', open);
    }

    function syncPackPicker() {
      const activePack = root.querySelector('[data-sipit-pack].active');
      if (packCurrent && activePack) {
        packCurrent.textContent = activePack.querySelector('.mt b')?.textContent?.trim() || activePack.dataset.pack || '';
      }
      packOffers.forEach((pack) => {
        pack.setAttribute('aria-selected', pack.classList.contains('active') ? 'true' : 'false');
      });
    }

    function findVariant(pack, flavor) {
      if (!pack || !flavor) return null;
      return variantMap.find((entry) => entry.pack === pack && entry.flavor === flavor) || null;
    }

    function getServingsCount() {
      if (!hasPackOffers) return servingsPerPouch;
      const activePack = root.querySelector('[data-sipit-pack].active');
      const pouchCount = parseInt(activePack?.dataset.pouchCount || '1', 10) || 1;
      return pouchCount * servingsPerPouch;
    }

    function formatMoney(amount) {
      const symbol = root.dataset.moneyFormat || '$';
      const value = Number.isFinite(amount) ? amount : 0;
      const cents = Math.round(value * 100);
      const formatted = (cents / 100).toFixed(2);
      if (symbol.includes('{{')) {
        return '$' + formatted;
      }
      return symbol.replace(/\{\{\s*amount\s*\}\}/, formatted);
    }

    function isSubscribeMode() {
      const activeMode = root.querySelector('[data-sipit-mode].active');
      return Boolean(
        activeMode &&
          (activeMode.dataset.subscribeMode === 'true' || activeMode.dataset.sellingPlan)
      );
    }

    function syncSellingPlanInput() {
      const subscribe = isSubscribeMode();
      if (frequencyWrap) {
        frequencyWrap.classList.toggle('is-hidden', !subscribe);
      }
      if (!frequencySelect) return;
      if (!subscribe) {
        frequencySelect.disabled = true;
        frequencySelect.removeAttribute('name');
        return;
      }
      frequencySelect.disabled = false;
      frequencySelect.setAttribute('name', 'selling_plan');
    }

    function getSelectedSellingPlanId() {
      syncSellingPlanInput();
      if (!isSubscribeMode() || !frequencySelect || frequencySelect.disabled) return '';
      return (frequencySelect.value || '').trim();
    }

    function refreshPrice() {
      const display = formatMoney(activePrice);
      if (btnPrice) btnPrice.textContent = display;
      if (priceNow) priceNow.textContent = display;
      if (sbPrice) sbPrice.textContent = display;
      if (buyNowPrice) buyNowPrice.textContent = display;
      if (perServe) {
        const per = (activePrice / getServingsCount()).toFixed(2);
        perServe.textContent = perServe.dataset.template.replace('__PER__', per);
      }

      const subscribe = isSubscribeMode();
      if (priceWas) priceWas.hidden = !subscribe;
      if (priceSave) priceSave.hidden = !subscribe;
    }

    function flavorKey(value) {
      return (value || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
    }

    function setMainImage(src, fit, alt) {
      if (!mainImg) return;
      if (src) mainImg.src = src;
      mainImg.dataset.fit = fit || 'product';
      if (typeof alt === 'string' && alt.length) mainImg.alt = alt;
    }

    function thumbMatchesFlavor(thumb, flavor) {
      const filterOn = root.dataset.galleryFilterFlavor !== 'false';
      const keys = (thumb.dataset.flavorKeys || '').replace(/-/g, '');
      const flavorNorm = flavorKey(flavor);
      if (!filterOn) return true;
      if (!flavorNorm) return true;
      if (!keys) return false;
      return keys.includes(`|${flavorNorm}|`);
    }

    function syncGalleryForFlavor(flavor, imgUrl) {
      let firstVisible = null;
      let preferredVisible = null;
      thumbs.forEach((thumb) => {
        const match = thumbMatchesFlavor(thumb, flavor);
        thumb.hidden = !match;
        thumb.classList.remove('active');
        if (match && !firstVisible) firstVisible = thumb;
        if (match && imgUrl && thumb.dataset.src === imgUrl) preferredVisible = thumb;
      });
      if (mainVid) mainVid.style.display = 'none';
      if (mainVidEl) mainVidEl.pause();
      if (mainImg) mainImg.style.display = 'block';
      const nextThumb = preferredVisible || firstVisible;
      if (nextThumb) {
        nextThumb.classList.add('active');
        setMainImage(nextThumb.dataset.src || imgUrl, nextThumb.dataset.fit, nextThumb.dataset.alt);
      } else if (imgUrl) {
        setMainImage(imgUrl, 'product');
      }
    }

    function applyVariant(entry) {
      if (!entry) return;
      currentEntry = entry;

      if (variantInput) {
        variantInput.value = entry.id;
        variantInput.disabled = !entry.available;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (priceWas && Number.isFinite(entry.price)) {
        priceWas.textContent = formatMoney(entry.price);
      }

      modes.forEach((mode) => {
        const planId = mode.dataset.sellingPlan || '';
        const modePrice =
          planId || mode.dataset.subscribeMode === 'true'
            ? getSubscribePriceForEntry(entry)
            : entry.price;
        if (Number.isFinite(modePrice)) mode.dataset.price = String(modePrice);
        const mp = mode.querySelector('.mp');
        if (mp && Number.isFinite(modePrice)) mp.textContent = formatMoney(modePrice);
      });

      const activeMode = root.querySelector('[data-sipit-mode].active');
      const activeModePrice = activeMode ? parseFloat(activeMode.dataset.price) : NaN;
      if (!Number.isNaN(activeModePrice)) {
        activePrice = activeModePrice;
      }

      const flavorName = entry.flavor || '';
      if (sbTitle && flavorName) {
        sbTitle.textContent =
          flavorName + ' · ' + (root.querySelector('[data-sipit-sb-sub]')?.textContent || 'Subscribe & save');
      }

      syncGalleryForFlavor(entry.flavor || '', entry.img);

      syncSellingPlanInput();
      refreshPrice();

      const disabled = !entry.available;
      if (buyNowBtn) buyNowBtn.disabled = disabled;
      if (addBtn) addBtn.disabled = disabled;
    }

    function syncFlavorVariantsForPack(pack) {
      if (!pack) return;
      flavs.forEach((flav) => {
        const flavor = flav.dataset.flavor || '';
        const entry = findVariant(pack, flavor);
        if (!entry) return;
        flav.dataset.variantId = String(entry.id);
        flav.dataset.price = String(entry.price);
        flav.dataset.subscribePrice = String(entry.subscribePrice);
        if (entry.img) flav.dataset.img = entry.img;
        if (entry.available) {
          flav.removeAttribute('disabled');
          flav.removeAttribute('aria-disabled');
        } else {
          flav.setAttribute('disabled', '');
          flav.setAttribute('aria-disabled', 'true');
        }
      });
    }

    function selectFlavor(flav) {
      if (!flav || flav.disabled) return;
      flavs.forEach((f) => f.classList.remove('active'));
      flav.classList.add('active');

      let entry = null;
      if (hasPackOffers) {
        entry = findVariant(getActivePack(), flav.dataset.flavor || '');
      } else {
        let subscribePrices = {};
        try {
          subscribePrices = JSON.parse(flav.dataset.subscribePrices || '{}');
        } catch (e) {
          subscribePrices = {};
        }
        entry = {
          id: Number(flav.dataset.variantId),
          price: parseFloat(flav.dataset.price),
          subscribePrice: parseFloat(flav.dataset.subscribePrice),
          subscribePrices,
          flavor: flav.dataset.flavor || '',
          img: flav.dataset.img,
          available: !flav.hasAttribute('disabled'),
        };
      }
      applyVariant(entry);
    }

    const mixEl = root.querySelector('[data-sipit-mix]');
    const singleFlavorEl = root.querySelector('[data-sipit-single-flavor]');
    const mixRows = mixEl ? Array.from(mixEl.querySelectorAll('[data-sipit-mix-row]')) : [];
    const mixCountEl = mixEl ? mixEl.querySelector('[data-sipit-mix-count]') : null;
    let mixCounts = mixRows.map(() => 0);

    function packCount() {
      const activePack = root.querySelector('[data-sipit-pack].active');
      const fromData = parseInt(activePack?.dataset.pouchCount || '', 10);
      if (Number.isFinite(fromData) && fromData > 0) return fromData;
      const parsed = parseInt((activePack?.dataset.pack || '').trim().split(' ')[0], 10);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
    }

    function mixTotal() {
      return mixCounts.reduce((sum, n) => sum + n, 0);
    }

    // Largest allocation other than `skip` — the pouch we borrow from or give back to.
    function largestOtherIndex(skip) {
      let best = -1;
      let idx = -1;
      mixCounts.forEach((count, i) => {
        if (i === skip) return;
        if (mixRows[i].dataset.unavailable === 'true') return;
        if (count > best) {
          best = count;
          idx = i;
        }
      });
      return idx;
    }

    function firstAvailableIndex() {
      const i = mixRows.findIndex((row) => row.dataset.unavailable !== 'true');
      return i < 0 ? 0 : i;
    }

    // The allocation must always add up to the pack size, so Add to cart is never invalid.
    function rebalanceMix() {
      if (!mixRows.length) return;
      const target = packCount();
      let total = mixTotal();
      let guard = 0;
      while (total !== target && guard < 64) {
        guard += 1;
        if (total > target) {
          const j = largestOtherIndex(-1);
          if (j < 0 || mixCounts[j] <= 0) break;
          mixCounts[j] -= 1;
          total -= 1;
        } else {
          const j = mixCounts.some((c) => c > 0) ? largestOtherIndex(-1) : firstAvailableIndex();
          if (j < 0) break;
          mixCounts[j] += 1;
          total += 1;
        }
      }
    }

    function renderMix() {
      if (!mixEl) return;
      const size = packCount();
      rebalanceMix();

      mixRows.forEach((row, i) => {
        const qty = row.querySelector('[data-sipit-mix-qty]');
        const minus = row.querySelector('[data-sipit-mix-minus]');
        const plus = row.querySelector('[data-sipit-mix-plus]');
        if (qty) qty.textContent = String(mixCounts[i]);
        if (minus) minus.disabled = mixCounts[i] <= 0;
        if (plus) plus.disabled = mixCounts[i] >= size || row.dataset.unavailable === 'true';
        row.classList.toggle('is-empty', mixCounts[i] <= 0);
      });

      if (mixCountEl) mixCountEl.textContent = size > 1 ? `${size} pouches` : '';

      const showMix = size > 1 && mixRows.length > 1;
      mixEl.hidden = !showMix;
      if (singleFlavorEl) singleFlavorEl.hidden = showMix;
    }

    function mixIndexForFlavor(name) {
      const key = String(name || '').trim().toLowerCase();
      return mixRows.findIndex((row) => (row.dataset.flavor || '').trim().toLowerCase() === key);
    }

    // Default the whole pack to the flavor already selected, so nothing changes unless asked.
    function resetMixToFlavor(name) {
      if (!mixRows.length) return;
      let idx = mixIndexForFlavor(name);
      if (idx < 0 || mixRows[idx].dataset.unavailable === 'true') idx = firstAvailableIndex();
      mixCounts = mixRows.map(() => 0);
      mixCounts[idx] = packCount();
      renderMix();
    }

    mixRows.forEach((row, i) => {
      row.querySelector('[data-sipit-mix-plus]')?.addEventListener('click', () => {
        const size = packCount();
        if (mixCounts[i] >= size) return;
        mixCounts[i] += 1;
        const j = largestOtherIndex(i);
        if (j >= 0 && mixCounts[j] > 0) mixCounts[j] -= 1;
        renderMix();
        previewMixFlavor(row.dataset.flavor);
      });
      row.querySelector('[data-sipit-mix-minus]')?.addEventListener('click', () => {
        if (mixCounts[i] <= 0) return;
        const j = largestOtherIndex(i);
        if (j < 0) return;
        mixCounts[i] -= 1;
        mixCounts[j] += 1;
        renderMix();
        previewMixFlavor(mixRows[j]?.dataset.flavor || row.dataset.flavor);
      });
    });

    // One line item per pack variant, or one per flavor once the pack is mixed.
    function getCartItems() {
      const base = getCartPayload();
      if (!mixEl || mixEl.hidden || packCount() < 2) return [base];

      const chosen = mixRows
        .map((row, i) => ({
          id: Number(row.dataset.variantId),
          quantity: mixCounts[i],
          flavor: row.dataset.flavor || '',
        }))
        .filter((item) => item.id && item.quantity > 0);

      if (!chosen.length) return [base];

      // All pouches same flavor — keep the Sipit Hydration Pack line item.
      if (chosen.length === 1) {
        const entry = findVariant(getActivePack(), chosen[0].flavor);
        if (entry) {
          const item = { id: entry.id, quantity: 1 };
          if (base.selling_plan) item.selling_plan = base.selling_plan;
          return [item];
        }
      }

      const packLabel = getActivePack() || `${packCount()} Pouches`;
      return chosen.map((row) => {
        const item = {
          id: row.id,
          quantity: row.quantity,
          properties: {
            _sipit_mix: '1',
            Pack: packLabel,
          },
        };
        if (base.selling_plan) item.selling_plan = base.selling_plan;
        return item;
      });
    }

    function previewMixFlavor(flavorName) {
      if (!flavorName) return;
      const match = Array.from(flavs).find(
        (f) => (f.dataset.flavor || '').trim().toLowerCase() === String(flavorName).trim().toLowerCase()
      );
      if (match) {
        selectFlavor(match);
        return;
      }
      syncGalleryForFlavor(flavorName, '');
    }

    function getCartPayload() {
      if (!hasPackOffers) syncQty();
      syncSellingPlanInput();
      const variantId = Number(variantInput?.value || 0);
      const quantity = hasPackOffers
        ? 1
        : parseInt(qInput?.value || form?.querySelector('input[name="quantity"]')?.value || '1', 10) || 1;
      const sellingPlan = getSelectedSellingPlanId();
      const item = { id: variantId, quantity };
      if (sellingPlan) item.selling_plan = Number(sellingPlan);
      return item;
    }

    async function addItemsToCart(items) {
      const res = await fetch((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data.status) {
        throw new Error(data.description || data.message || 'Could not add to cart.');
      }
      return data;
    }

    function openCartDrawer() {
      const trigger =
        document.querySelector('[data-testid="cart-drawer-trigger"]') ||
        document.querySelector('[aria-controls="cart-drawer"]');
      if (trigger) {
        trigger.click();
        return;
      }
      window.location.href = '/cart';
    }

    function flashAdded(btn) {
      if (!btn) return;
      const original = btn.innerHTML;
      btn.innerHTML = btn.dataset.addedText || 'Added ✓';
      btn.style.background = 'var(--teal)';
      btn.style.color = '#062a2d';
      setTimeout(() => {
        btn.innerHTML = original;
        btn.style.background = '';
        btn.style.color = '';
      }, 1300);
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach((t) => t.classList.remove('active'));
        thumb.classList.add('active');
        const type = thumb.dataset.mediaType;
        if (type === 'video' && mainVidEl) {
          if (mainImg) mainImg.style.display = 'none';
          if (mainVid) mainVid.style.display = 'block';
          mainVidEl.play().catch(() => {});
        } else {
          if (mainVidEl) mainVidEl.pause();
          if (mainVid) mainVid.style.display = 'none';
          if (mainImg) {
            mainImg.style.display = 'block';
            setMainImage(thumb.dataset.src, thumb.dataset.fit, thumb.dataset.alt);
          }
        }
      });
    });

    packOffers.forEach((pack) => {
      pack.addEventListener('click', () => {
        packOffers.forEach((p) => p.classList.remove('active'));
        pack.classList.add('active');
        syncPackPicker();
        setPackPickerOpen(false);
        syncFlavorVariantsForPack(pack.dataset.pack || '');

        const activeFlav = root.querySelector('[data-sipit-flav].active') || flavs[0];
        if (activeFlav) selectFlavor(activeFlav);
        renderMix();
      });
    });

    if (packTrigger && packMenu) {
      packTrigger.addEventListener('click', () => {
        setPackPickerOpen(packMenu.hidden);
      });
      document.addEventListener('click', (event) => {
        if (packPicker && !packPicker.contains(event.target)) setPackPickerOpen(false);
      });
      syncPackPicker();
    }

    flavs.forEach((flav) => {
      flav.addEventListener('click', () => {
        selectFlavor(flav);
        resetMixToFlavor(flav.dataset.flavor);
      });
    });

    modes.forEach((mode) => {
      mode.addEventListener('click', () => {
        modes.forEach((m) => m.classList.remove('active'));
        mode.classList.add('active');

        const price = parseFloat(mode.dataset.price);
        if (!Number.isNaN(price)) {
          activePrice = price;
          refreshPrice();
        }

        syncSellingPlanInput();

        const label = mode.dataset.label || '';
        const sbSub = root.querySelector('[data-sipit-sb-sub]');
        if (sbSub && label) sbSub.textContent = label;
      });
    });

    if (frequencySelect) {
      frequencySelect.addEventListener('change', () => {
        syncSellingPlanInput();
        if (!currentEntry || !isSubscribeMode()) return;

        const price = getSubscribePriceForEntry(currentEntry);
        if (!Number.isFinite(price)) return;

        const subscribeMode = root.querySelector('[data-sipit-mode][data-subscribe-mode="true"]');
        if (subscribeMode) {
          subscribeMode.dataset.price = String(price);
          const mp = subscribeMode.querySelector('.mp');
          if (mp) mp.textContent = formatMoney(price);
        }

        activePrice = price;
        refreshPrice();
      });
    }

    syncSellingPlanInput();

    if (qPlus && qInput) {
      qPlus.addEventListener('click', () => {
        const max = parseInt(qInput.max || '99', 10);
        qInput.value = String(Math.min(max, (parseInt(qInput.value, 10) || 1) + 1));
        syncQty();
      });
    }

    if (qMinus && qInput) {
      qMinus.addEventListener('click', () => {
        const min = parseInt(qInput.min || '1', 10);
        qInput.value = String(Math.max(min, (parseInt(qInput.value, 10) || 1) - 1));
        syncQty();
      });
    }

    if (qInput) {
      qInput.addEventListener('input', () => {
        const min = parseInt(qInput.min || '1', 10);
        const max = parseInt(qInput.max || '99', 10);
        let v = parseInt(String(qInput.value).replace(/\D/g, ''), 10) || min;
        qInput.value = String(Math.min(max, Math.max(min, v)));
        syncQty();
      });
    }

    function syncQty() {
      if (!form || !qInput) return;
      const qtyField = form.querySelector('input[name="quantity"]');
      if (qtyField) qtyField.value = qInput.value;
    }

    async function handleAddToCart(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
      if (adding || addBtn?.disabled) return;

      const items = getCartItems();
      if (!items.length || !items[0].id) return;

      adding = true;
      if (addBtn) addBtn.disabled = true;

      try {
        await addItemsToCart(items);
        flashAdded(addBtn);
        if (sbAdd) flashAdded(sbAdd);
        openCartDrawer();
      } catch (err) {
        window.alert(err.message || 'Could not add to cart.');
      } finally {
        adding = false;
        if (addBtn) addBtn.disabled = false;
      }
    }

    if (sbAdd && addBtn) {
      sbAdd.addEventListener('click', (e) => {
        e.preventDefault();
        handleAddToCart(e);
      });
    }

    if (form) {
      // Capture before Horizon product-form-component so selling_plan is always applied.
      form.addEventListener('submit', handleAddToCart, true);
    }

    if (buyNowBtn && variantInput) {
      buyNowBtn.addEventListener('click', async () => {
        if (buyNowBtn.disabled || adding) return;

        const items = getCartItems();
        if (!items.length || !items[0].id) return;

        buyNowBtn.disabled = true;
        const original = buyNowBtn.innerHTML;
        buyNowBtn.textContent = 'Redirecting…';

        try {
          await fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
          await addItemsToCart(items);
          window.location.href = '/checkout';
        } catch {
          buyNowBtn.disabled = false;
          buyNowBtn.innerHTML = original;
        }
      });
    }

    if (stickyBar && addBtn) {
      const footer = document.querySelector('#shopify-section-group-footer-group, footer');
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.target === addBtn) {
              stickyBar.dataset.past = e.isIntersecting ? '0' : '1';
            }
            if (footer && e.target === footer) {
              stickyBar.dataset.foot = e.isIntersecting ? '1' : '0';
            }
            stickyBar.classList.toggle(
              'show',
              stickyBar.dataset.past === '1' && stickyBar.dataset.foot !== '1'
            );
          });
        },
        { threshold: 0 }
      );
      io.observe(addBtn);
      if (footer) io.observe(footer);
    }

    syncSellingPlanInput();
    if (hasPackOffers) {
      syncFlavorVariantsForPack(getActivePack());
      const activeFlav = root.querySelector('[data-sipit-flav].active') || flavs[0];
      if (activeFlav) selectFlavor(activeFlav);
      resetMixToFlavor(getActiveFlavor());
    } else {
      refreshPrice();
      syncQty();
    }
  }

  function boot() {
    document.querySelectorAll('[data-sipit-pdp]').forEach(initSipitProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-sipit-pdp]');
    if (root) initSipitProduct(root);
  });
})();

(function () {
  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isMobileCarousel() {
    return window.matchMedia('(max-width: 980px)').matches;
  }

  function initReviewCarousel(carousel) {
    if (!carousel || carousel.dataset.sipitRevInit === '1') return;
    carousel.dataset.sipitRevInit = '1';

    const card = carousel.querySelector('.rev');
    if (!card) return;

    let paused = false;
    let timer = null;
    let resumeTimer = null;

    function stepWidth() {
      const style = window.getComputedStyle(card);
      const gap = parseFloat(style.marginRight) || 12;
      const track = carousel.querySelector('.rev-track');
      const trackGap = track ? parseFloat(window.getComputedStyle(track).gap) || 12 : 12;
      return card.getBoundingClientRect().width + trackGap;
    }

    function advance() {
      if (paused || !isMobileCarousel() || prefersReducedMotion()) return;
      const max = carousel.scrollWidth - carousel.clientWidth;
      if (max <= 4) return;
      const next = carousel.scrollLeft + stepWidth();
      if (next >= max - 12) {
        carousel.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        carousel.scrollBy({ left: stepWidth(), behavior: 'smooth' });
      }
    }

    function start() {
      clearInterval(timer);
      if (!isMobileCarousel() || prefersReducedMotion()) return;
      timer = window.setInterval(advance, 3800);
    }

    function pause() {
      paused = true;
      clearTimeout(resumeTimer);
    }

    function resumeSoon() {
      clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(() => {
        paused = false;
      }, 2500);
    }

    carousel.addEventListener('pointerdown', pause);
    carousel.addEventListener('touchstart', pause, { passive: true });
    carousel.addEventListener('pointerup', resumeSoon);
    carousel.addEventListener('touchend', resumeSoon, { passive: true });
    carousel.addEventListener('scroll', () => {
      pause();
      resumeSoon();
    }, { passive: true });

    start();
    window.addEventListener('resize', start);
  }

  function bootReviews() {
    document.querySelectorAll('[data-sipit-rev-carousel]').forEach(initReviewCarousel);
  }

  function openLooxWriteForm(productId) {
    if (!productId) return false;
    var id = String(productId);
    try {
      if (window.LOOX) {
        window.LOOX.productId = window.LOOX.productId || id;
        if (typeof window.LOOX.showReviewForm === 'function') {
          window.LOOX.showReviewForm(id);
          return true;
        }
      }
      if (typeof window.looxWrite === 'function') {
        window.looxWrite(id);
        return true;
      }
    } catch (err) {
      console.warn('Loox write form failed', err);
    }
    return false;
  }

  function waitForLooxWrite(productId, attempts) {
    var left = typeof attempts === 'number' ? attempts : 50;
    if (openLooxWriteForm(productId)) return;
    if (left <= 0) return;
    setTimeout(function () {
      waitForLooxWrite(productId, left - 1);
    }, 120);
  }

  function resolveLooxProductId(fromEl) {
    if (fromEl && fromEl.getAttribute('data-product-id')) {
      return fromEl.getAttribute('data-product-id');
    }
    var mount = document.getElementById('looxReviews');
    if (mount && mount.getAttribute('data-product-id')) {
      return mount.getAttribute('data-product-id');
    }
    var section = document.querySelector('.sipit-product-reviews[data-product-id]');
    if (section) return section.getAttribute('data-product-id');
    return null;
  }

  function bootLooxWrite() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sipit-loox-write]');
      if (!btn) return;
      var productId = resolveLooxProductId(btn);
      if (!productId) return;
      e.preventDefault();
      waitForLooxWrite(productId);
    });

    // Landed from Loox review email / ?ref=review — open form once Loox is ready
    if (/(?:\?|&)ref=review(?:&|$)/i.test(window.location.search || '')) {
      var productId = resolveLooxProductId(document.querySelector('[data-sipit-loox-write]'));
      if (productId) waitForLooxWrite(productId);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootReviews);
    document.addEventListener('DOMContentLoaded', bootLooxWrite);
  } else {
    bootReviews();
    bootLooxWrite();
  }

  document.addEventListener('shopify:section:load', bootReviews);
})();
